import './RankingsBox.css'

import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { RANKINGS } from './constants'
import RankingsBoxFiltersContainer from './RankingsBoxFiltersContainer'
import RankingsBoxTableContainer from './RankingsBoxTableContainer'
import RankingsPerHourContainer from './RankingsPerHourContainer'

interface Props {
  className: string
  isFetchError: boolean
  isFetching: boolean
  ranking: string
}

function RankingsBox({ className, isFetchError, isFetching, ranking }: Props) {
  const { t: translate } = useTranslation()

  return (
    <>
      <div className="rankings-divider" />
      <div className={classNames('rankings-box', className)}>
        <div className="rankings-box-header">
          <i className="fm fm-screenrotate" /> {translate('rankings.title')}
        </div>

        <RankingsBoxFiltersContainer />

        {isFetchError && <div className="rankings-box-fetch-error">{translate('rankings.fetchError')}</div>}
        {!isFetching && !isFetchError && ranking !== RANKINGS.HOURS_REVENUE && <RankingsBoxTableContainer />}
        {!isFetching && !isFetchError && ranking === RANKINGS.HOURS_REVENUE && <RankingsPerHourContainer />}
      </div>
    </>
  )
}

export default RankingsBox
